import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cleanHtmlContent',
  pure: true,
  standalone: false
})
export class CleanHtmlContentPipe implements PipeTransform {

  transform(content: string): string {
    if (!content) return '';

    let processed = content;

    processed = processed.replace(/<\/(h[1-6])>/gi, ' - ');
    processed = processed.replace(/<\/(p|div|li|tr)>/gi, ' ');
    processed = processed.replace(/<br\s*\/?>/gi, ' ');

    const doc = new DOMParser().parseFromString(processed, 'text/html');
    const text = doc.body.textContent || '';

    return text.replace(/\s+/g, ' ').trim();
  }
}
